import { formatPriceToman } from '../../utils/formatPriceToman';

/** پالت پاستلی برای نمودارهای گزارش */
export const REPORT_CHART_COLORS = {
  sky: '#789DBC',
  mint: '#C9E9D2',
  teal: '#79B4B7',
  mist: '#B8D4E8',
  sage: '#D4ECC9',
};

export const REPORT_CHART_PALETTE = [
  REPORT_CHART_COLORS.sky,
  REPORT_CHART_COLORS.mint,
  REPORT_CHART_COLORS.teal,
  REPORT_CHART_COLORS.mist,
  REPORT_CHART_COLORS.sage,
  '#A8C8DC',
  '#C5E0D8',
];

/** جداکنندهٔ هزارگان + ارقام فارسی (برای تعداد و محور نمودار) */
export function formatReportNumberFa(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return Number(value).toLocaleString('fa-IR');
}

/** نمایش مبلغ در گزارش‌ها */
export const formatReportMoneyFa = formatPriceToman;

/** نمایش مبلغ در ستون جدول گزارش */
export function formatReportTableAmount(value, currencySymbol) {
  if (value == null || value === '' || value === '-') return '—';
  return formatPriceToman(value, { currencySymbol: currencySymbol || undefined });
}
